export default __webpack_public_path__ + "static/media/demoBackgroundB.44f90ca8.jpg";